import React from 'react';
import PageLayout from '../../layout/PageLayout';
import KimSuppliersDynamics from '../../layout/KimGroup/KimSuppliersDynamics';

const KimSuppliersDynamicsPage: React.FC = () => (
  <PageLayout>
    <KimSuppliersDynamics />
  </PageLayout>
);

export default KimSuppliersDynamicsPage;
